<template>
  <transition name="fade">
    <div id="add-job">
      <h2>{{ msg }}</h2>
      <form @submit.prevent="post" autocomplete="off">
        <section id="programs">
          <div class="selection">
            <template v-for="prog in programs">
              <input
                @click="getProgramInfo(prog.title)"
                required
                type="radio"
                name="program"
                :id="prog.title"
                :value="prog.title"
                v-model="user.program"
                :key="prog.title"
              >
              <label tabindex="0" :for="prog.title" :key="prog.title">{{ prog.title }}</label>
            </template>
          </div>
          <div class="paper" :class="unlocked">
            <button
              @click.prevent="toggle_lock"
              title="Add a new program to the system."
            >{{ unlockSym }}</button>
            <template v-if="isLocked">
              <template v-if="selectedProgram.title == null">
                <h3>⯇ Select a program from the list.</h3>
              </template>
              <template v-else>
                <h3>{{ selectedProgram.title }}</h3>
                <p>{{ selectedProgram.info }}</p>
                <p>
                  <a :href="selectedProgram.link">Paper</a>
                </p>
                <p>
                  <a href="https://biomall.cs.uno.edu/software">Download local copy of this software.</a>
                </p>
              </template>
            </template>
            <template v-else>
              <addProgram/>
            </template>
          </div>
        </section>
        <input id="username" required placeholder="username/email" type="text" v-model="user.username">
        <input id="title" required placeholder="Job Title / Protein ID (please keep it short and avoid spaces)" type="text" v-model="user.title" :class="shrunk">
        <template v-if="user.program == '3DIGARS3.0'">
          <div class="checkbox fasta">
            <input type="checkbox" id="manual-fasta" v-model="uploadFasta">
            <label tabindex="0" for="manual-fasta">Upload FASTA file</label>
          </div>
          <textarea
            v-if="!uploadFasta"
            class="fasta"
            required
            placeholder="FASTA Input"
            v-model="user.input"
          ></textarea>
          <template v-if="uploadFasta">
            <input type="file" ref="fasta" id="fasta" @change="changeFile('fasta')">
            <label
              tabindex="0"
              for="fasta"
              class="file paper fasta"
              :class="{dragging: fastaDrag}"
              @dragover.prevent="fastaDrag = true"
              @dragleave="fastaDrag = false"
              @drop.prevent="dropFile($event, 'fasta')"
            >
              <template
                v-if="fastaFile.name"
              >The fasta file "{{ fastaFile.name }}" will be uploaded.</template>
              <template v-else>Upload a fasta file</template>
            </label>
          </template>
          <input type="file" ref="pdb" id="pdb" @change="changeFile('pdb')">
          <label
            tabindex="0"
            for="pdb"
            class="file paper pdb"
            :class="{dragging: pdbDrag}"
            @dragover.prevent="pdbDrag = true"
            @dragleave="pdbDrag = false"
            @drop.prevent="dropFile($event, 'pdb')"
          >
            <template v-if="pdbFile.name">The pdb file "{{ pdbFile.name }}" will be uploaded.</template>
            <template v-else>Upload a pdb file</template>
          </label>
        </template>
        <template v-else>
          <textarea required placeholder="Job Input / Protein Sequence" v-model="user.input"></textarea>
        </template>
        <template v-if="exampleInput">
          <button id="exampleBtn" v-on:click.prevent="setNewValue">Example</button>
        </template>
        <!-- <div class="checkbox">
				<input type="checkbox" v-model="email" id="email">
				<label tabindex="0" for="email">Email me the output!</label>
        </div>-->
        <div class="checkbox">
          <input type="checkbox" v-model="passkey" id="passkey">
          <label tabindex="0" for="passkey">Make my job private!</label>
        </div>
        <input v-if="email" v-model="user.email" type="email" placeholder="email (optional)">
        <input
          v-if="passkey"
          v-model="user.passkey"
          type="password"
          class="passkey"
          placeholder="passkey (optional)"
        >
        <button>Add Job</button>
      </form>
    </div>
  </transition>
</template>
<script>
import axios from "axios";
import addProgram from "@/components/addProgram";
export default {
  name: "addJob",
  components: {
    addProgram
  },
  data() {
    return {
      msg: "Add a new Job!",
      pdbFile: {},
      pdbDrag: false,
      fastaFile: {},
      fastaDrag: false,
      programs: [],
      selectedProgram: {},
      username: '',
      email: false,
      passkey: false,
      isLocked: true,
      unlockSym: "+",
      uploadFasta: false,
      exampleInput: false,
      user: {
        program: "",
        title: "",
        email: "",
        input: "",
        passkey: "",
        outFile: false
      }
    };
  },
  methods: {
    setNewValue: function() {
      let example;
      if (this.selectedProgram !== null)
        example = this.selectedProgram.exampleInput;
      if (example !== null) {
        this.user.title = example.title;
        this.user.input = example.input;
      }
    },
    post() {
      const data = new FormData();
      data.append("user", JSON.stringify(this.user));
      if (this.pdbFile) data.append("pdbFile", this.pdbFile);
      if (this.fastaFile) data.append("fastaFile", this.fastaFile);
      axios
        .post(process.env.VUE_APP_API_HOST + "/api/users", data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          console.log(res);
          this.$router.push("/");
        })
        .catch(err => console.log(err));
    },
    lock_menu() {
      this.isLocked = true;
      this.unlockSym = "+";
    },
    unlock_menu() {
      this.isLocked = false;
      this.unlockSym = "×";
    },
    toggle_lock() {
      if (this.isLocked) {
        this.unlock_menu();
      } else {
        this.lock_menu();
      }
    },
    toggle_program() {
      this.lock_menu();
      this.isToggled = !this.isToggled;
    },
    getPrograms() {
      axios
        .get(process.env.VUE_APP_API_HOST + "/api/programs")
        .then(res => {
          this.programs = res.data;
          this.programs.sort((a, b) => a.title > b.title)
        }).catch(err => console.log(err));
    },
    getProgramInfo(title) {
      this.selectedProgram = this.programs.find(prog => prog.title == title);
      if (this.selectedProgram.exampleInput.title != "") this.exampleInput = true;
      else this.exampleInput = false;
      this.lock_menu();
    },
    changeFile(file) {
      if (file == "fasta") this.fastaFile = this.$refs.fasta.files[0];
      else if (file == "pdb") this.pdbFile = this.$refs.pdb.files[0];
    },
    dragOver() {
      this.dragging = true;
    },
    dragLeave() {
      this.dragging = false;
    },
    dropFile(e, file) {
      let dt = e.dataTransfer;
      if (dt.items) {
        for (let i = 0; i < dt.items.length; i++) {
          if (dt.items[i].kind == "file") {
            if (file == "pdb") this.pdbFile = dt.items[i].getAsFile();
            else if (file == "fasta") this.fastaFile = dt.items[i].getAsFile();
          }
        }
      } else {
        for (let i = 0; i < dt.files.length; i++) {
          if (file == "pdb") this.pdbFile = dt.files[i];
          else if (file == "fasta") this.fastaFile = dt.files[i];
        }
      }
      this.dragLeave();
    }
  },
  computed: {
    unlocked() {
      return {
        unlocked: !this.isLocked && !this.error
      };
		},
		shrunk() {
			return {
				shrink: this.exampleInput && !this.error
			}
		}
  },
  mounted() {
    this.getPrograms();
  }
};
</script>
<style scoped>
#add-job > form {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(12, 1fr);
  grid-gap: var(--gap-huge);
}
#programs {
  display: grid;
  grid-column: 1 / 6;
  grid-row: 1 / 6;
  max-height: 100%;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: var(--gap-huge);
  position: relative;
}
/* #programs .paper {
	transition: width 0.4s;
} */
#programs .paper.unlocked {
  box-shadow: 0 100px 200px var(--shadow);
}
textarea {
  grid-column: 1 / 6;
  grid-row: 7 / 11;
  resize: none;
}
input[type="file"] {
  display: none;
}
.checkbox.fasta {
  grid-row: 7 / 9;
}
.fasta {
  grid-column: 3 / 6;
  grid-row: 8 / 11;
}
#username {
  grid-row: 6 / 7;
  grid-column: 1 / 2;
}
#title {
  grid-row: 6 / 7;
  grid-column: 2 / 6;
}
#title.shrink {
	grid-column: 2/5;
}
#exampleBtn {
  grid-column: 5 / 6;
  grid-row: 6 / 7;
}
.pdb {
  grid-column: 1 / 3;
  grid-row: 8 / 11;
}
label.file {
  display: flex;
  align-items: center;
  justify-content: center;
}
label.file:hover,
label.pdb:focus {
  outline: none;
  cursor: pointer;
  box-shadow: 5px 5px 0 var(--shadow);
}
label.dragging {
  border-color: var(--accent-light);
  border-style: dashed;
}
.checkbox {
  display: block;
  grid-row: 11 / 12;
  grid-column: 1 / 3;
}
/* .checkbox:last-of-type {
  grid-column: 1 / 4;
} */
/* input[type=email] {
  grid-column: 1 / 3;
  grid-row: 12 / 13;
	max-width: calc(100% - 20px);
} */
.passkey {
  -moz-appearance: textfield;
  grid-column: 3 / 5;
  grid-row: 11 / 12;
  box-sizing: border-box;
  max-width: 100%;
}
button:last-of-type {
  grid-column: 5 / 6;
  grid-row: 11 / 12;
}
#programs .paper {
  grid-column: 3 / 6;
  padding: var(--gap-huge);
}
#programs .selection {
  grid-column: 1 / 3;
  max-height: calc(6 * (1.2em + 34px));
  overflow-y: auto;
}
@media (max-width: 500px) {
  #programs {
    display: block;
  }
}
#programs .paper.unlocked {
  padding-right: var(--gap);
  padding-bottom: var(--gap);
}
#programs .selection input[type="radio"] {
  display: none;
}
#programs .selection label {
  display: block;
  border: 2px solid transparent;
  background: var(--canvas-light);
  border-top-color: white;
  border-left-color: white;
  margin-bottom: var(--gap);
  border-radius: 5px;
  font-size: 1.2em;
  line-height: 1;
  padding: var(--gap);
}
#programs .selection label:hover,
#programs .selection label:focus,
#programs .selection input[type="radio"]:checked + label {
  outline: none;
  color: white;
  border-top-color: var(--accent-light);
  border-left-color: var(--accent-light);
  border-bottom-color: var(--accent-dark);
  border-right-color: var(--accent-dark);
  cursor: pointer;
  text-shadow: 0px -2px 2px var(--accent-dark), 0px 2px 2px var(--accent-light);
  background: var(--accent);
}
</style>
